module.exports = __webpack_public_path__ + "static/classy-event-19dcb64bd8a31786f8fcdf6f61c44e63.jpeg";